import { createAction, props } from '@ngrx/store';
import { Manual } from './manuals.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records manuals'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records manuals success', 
    props<{ listData: Manual[] }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records manuals failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record manuals',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record manuals success', 
    props<{ singleData: Manual }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record manuals failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state faq',
);